import { createClient } from "@connectrpc/connect";
import {
  BaseGrpcCatalogService,
  GrpcCatalogoFetchResult,
} from "../../../../../base/services/BaseGrpcCatalogService";
import { grpcTransportProvider } from "../../../../../comun/services/grpc/GrpcTransport";
import { mapConnectError } from "../../../../../comun/services/grpc/mapConnectError";
import {
  CatalogosPesajeService,
  RazaAnimalItem,
} from "../../../../../generated/grpc/catalogos_pesaje_pb";

/** Variante gRPC-Web (con delta) de `RazaAnimalGetCatalogService` (ver ese archivo). */
export class RazaAnimalGrpcCatalogService extends BaseGrpcCatalogService<RazaAnimalItem> {
  protected readonly storeName = "razasAnimal" as const;
  protected readonly sortFieldName = "raza";

  protected async fetchAsync(ultimaSincronizacion: bigint): Promise<GrpcCatalogoFetchResult<RazaAnimalItem>> {
    const client = createClient(CatalogosPesajeService, grpcTransportProvider.get());

    try {
      const response = await client.listRazaAnimales({ ultimaSincronizacion });
      return { items: response.items, timestampSincronizacion: response.timestampSincronizacion };
    } catch (error) {
      throw mapConnectError(error);
    }
  }
}

/** Singleton del servicio gRPC del catálogo de razas de animal. */
export const razaAnimalGrpcCatalogService = new RazaAnimalGrpcCatalogService();
